import { useState } from "react";
import PayementTotalSalaireChequeFN from "./PayementMethods/PayementTotalSalaireChequeFN";
import PayementTotalSalaireVirementFN from "./PayementMethods/PayementTotalSalaireVirementFN";
import PayementTotalSalaireEspeceFN from "./PayementMethods/PayementTotalSalaireEspeceFN";
import PayementTotalSalaireEnLigneFN from "./PayementMethods/PayementTotalSalaireEnLigneFN";

const MethodePayementSalaireTotal = () => {
  const [methodePayement, setMethodePayement] = useState("");

  const createUIPayement = () => {
    
    if (methodePayement === "CHEQUE") {
      return <PayementTotalSalaireChequeFN />;
    } else if (methodePayement === "VIREMENT") {
      return <PayementTotalSalaireVirementFN />;
    } else if (methodePayement === "ESPECE") {
      return <PayementTotalSalaireEspeceFN />;
    } else if (methodePayement === "ENLIGNE") {
      return <PayementTotalSalaireEnLigneFN />;
    }
  };
  const handleChangePayement = (e) => {
    let payement = e.target.value;
    setMethodePayement(payement);
  };
  const listOptionsPayement = () => {
    return (
      <select class="form-control" onChange={handleChangePayement}>
        <option key={0} value={0}>
          Sélectionner un mode de payement
        </option>
        <option key={1} value={"ESPECE"}>
          Espèce
        </option>
        <option key={2} value={"ENLIGNE"}>
          En ligne
        </option>
        <option key={3} value={"CHEQUE"}>
          Chèques / Traites
        </option>
        <option key={4} value={"VIREMENT"}>
          Virement
        </option>
      </select>
    );
  };
  return (
    <div className="card-body">
      <h5 className="card-title">Choisir le mode de payement </h5>
      <div class="row">
        <div class="col-2"></div>
        <div class="col-10">{listOptionsPayement()}</div>
      </div>

      {createUIPayement()}
      <br />
    </div>
  );
};
export default MethodePayementSalaireTotal;
